import type { Metadata } from '@lumapps/metadata/types';

import type { MetadataMap } from '../types';

/**
 * Creates a map from metadata ID to Metadata object for efficient lookups
 */
export const createMetadataMap = (metadataList: Metadata[]): MetadataMap => {
    const map = new Map<string, Metadata>();

    metadataList.forEach((metadata) => {
        map.set(metadata.id, metadata);
    });

    return map;
};
